import { Box, Typography } from "@mui/material";
import { OccupationInfo } from "../../../../interfaces/DTO/mislaka_xml_insurence_models";

interface OccupationInfoCardProps {
  occupation: OccupationInfo;
}

interface FieldDef {
  field: keyof OccupationInfo;
  label: string;
}

const occupationFieldDefs: FieldDef[] = [
  { field: 'occupation_code', label: 'קוד המקצוע' },
  { field: 'new_occupation_field', label: 'תחום עיסוק חדש' },
];

export const OccupationInfoCard: React.FC<OccupationInfoCardProps> = ({ occupation }) => {
  return (
    <Box
      sx={{
        width: "100%",
        mb: 2,
        p: 2,
        borderRadius: "8px",
        backgroundColor: "background.default",
        boxShadow: 1,
      }}
    >
      {occupationFieldDefs.map(({ field, label }) => {
        const value = occupation[field];
        if (value == null || value === '') return null;

        return (
          <Typography variant="body1" key={field as string}>
            <strong>{label}:</strong> {value}
          </Typography>
        );
      })}
    </Box>
  );
};
